import { render, staticRenderFns } from "./Pack.vue?vue&type=template&id=1d677c49&"
import script from "./Pack.vue?vue&type=script&lang=js&"
export * from "./Pack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports